import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import { keyByProperty } from '../../../../../helpers/core';
import Api from '../../../../../helpers/api';
import { t } from '../../../../../i18n';

const api = new Api('companies/:company_id/company_pricing_agreements');
const updateOldApi = new Api('companies/:company_id/company_pricing_agreements/:company_pricing_agreement_id');
const updateNewApi = new Api('companies/:company_id/company_pricing_agreements');

function getApiInstance(isCreation, featureFlag) {
  if (featureFlag) {
    return updateNewApi.multiparamsUpdateItem;
  }

  return isCreation ? api.multipleParamsCreateItem : updateOldApi.multiparamsUpdateItem;
}

function getRequestBody(isCreation, featureFlag, formData, company_id, company_pricing_agreement_id) {
  if (!featureFlag) {
    return {
      data: { company_pricing_agreement: formData[0] },
      params: { company_id, ...(isCreation ? {} : { company_pricing_agreement_id }) },
    };
  }

  return { data: { company_pricing_agreements: formData }, params: { company_id } };
}

function* loadRequest(data) {
  try {
    const { company_id } = data.payload;

    const result = yield call(sendRequest, api.load, { id: company_id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadSuccess(result.data.success));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData(data) {
  try {
    const { company_id } = data.payload;

    const result = yield call(sendRequest, api.loadFormData, { id: company_id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadFormDataSuccess(result.data.success));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadCompanyPricingAgreementsData(data) {
  try {
    const { company_id } = data.payload;

    const result = yield call(sendRequest, api.load, { id: company_id }, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadCompanyPricingAgreementsDataSuccess(result.data.success));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* saveRules({ payload }) {
  try {
    const { editForm, company_id, company_pricing_agreement_id, pricingAgreementDistrictsEnabled } = payload;
    const isCreation = !company_pricing_agreement_id;

    const formData = editForm.map(rule => {
      const item = keyByProperty(Object.values(rule), 'name', prop => prop.value);

      if (item.all_districts) {
        item.district_ids = [];
      }

      delete item.all_districts;
      delete item.custom_id;

      return item;
    });

    const result = yield call(
      sendRequest,
      getApiInstance(isCreation, pricingAgreementDistrictsEnabled),
      getRequestBody(isCreation, pricingAgreementDistrictsEnabled, formData, company_id, company_pricing_agreement_id),
      notifications.REQUEST_ERROR,
    );

    if (result?.data) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(`dash.common.notification.${isCreation ? 'created' : 'updated'}_successfully`, {
            item: t('dash.companies.company.contract_specific_agreements_rules'),
          }),
        }),
      );
      yield put(push(`/companies/${company_id}`));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_REQUEST, loadRequest),
    takeEvery(actions.CREATE, loadFormData),
    takeEvery(actions.EDIT, loadFormData),
    takeEvery(actions.EDIT, loadCompanyPricingAgreementsData),
    takeEvery(actions.SAVE_RULES, saveRules),
  ]);
}
